import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after it has stopped changing for
 * `delayMs`. Use it to decouple a fast-changing source (e.g. a text input) from
 * an expensive consumer (URL writes, network calls) without throttling the input
 * itself. Each new `value` resets the timer; on unmount the pending timer clears.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
